export default __webpack_public_path__ + "static/media/f-lubricantes-y-aditivos.b54073b3.png";